import {Projecte} from "./Projecte";
import {DefaultUsuari, Usuari} from "./Usuari";

export type AlumneInfo = {
    alumne: Usuari;
    projectes: Projecte[];
    aules: any;
}

export const DefaultAulumneInfo: AlumneInfo = {
    alumne: DefaultUsuari,
    projectes: [],
    aules: [],
}
